/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfHoursV1MoneyMarketScheduleState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_HOURS_V1_MONEY_MARKET_SCHEDULE_STATE_ENTITY_NAME = 'ixf.hours.v1.MoneyMarketSchedule';
export const ixfHoursV1MoneyMarketScheduleStateEntity = new schema.Entity<IxfHoursV1MoneyMarketScheduleState>(IXF_HOURS_V1_MONEY_MARKET_SCHEDULE_STATE_ENTITY_NAME, {}, { idAttribute: (entity: IxfHoursV1MoneyMarketScheduleState) => `${entity.region}-${entity.exposure}` });

